export const MIN_ASSET_DURATION = 6;
export const MIN_SONG_DURATION = window.MIN_SONG_DURATION || 30;
export const DOWNLOAD_VIDEO_EXTENSION = '.mp4';
export const MIN_PHOTOS_NUMBER = 1;
export const MAX_VIDEO_DURATION = 30;
